import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CampaignDTO } from "../models/campaignDTO.model";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Zone } from "../models/zone.model";
import { map } from "rxjs/operators";
import { FileService } from "./file-service";
import { Campaign } from "../models/campaign.model";

@Injectable({
  providedIn: "root"
})
export class CampaignService {
  private API_CAMPAIGNS_URL = environment.API_URL + "api/campaigns";
  private API_CAMPAIGNZONES_URL = environment.API_URL + "api/campaignzonas/";
  private API_CAMPAIGNZONES_CLONE_URL = environment.API_URL + "api/campaignzonas/clone";
  private API_SCOPE_DOWNLOAD_URL = environment.API_URL + "api/Reaches/downloadusers";
  private API_SCOPE_UPLOAD_URL = environment.API_URL + "api/Reaches/uploadusers";
  private API_CAMPAIGN_USER_URL = environment.API_URL + "api/Campaigns/user";

  constructor(private fileService: FileService, private http: HttpClient) {}

  getCampaigns(): Observable<CampaignDTO[]> {
    let httpHeaders = new HttpHeaders();
    httpHeaders.set("Content-Type", "application/json");

    return this.http.get<CampaignDTO[]>(this.API_CAMPAIGNS_URL, { headers: httpHeaders });
  }

  getCampaignData(id?): Observable<Campaign> {
    if (id) {
      return this.http.get<Campaign>(this.API_CAMPAIGN_USER_URL + "/" + id);
    }
    return this.http.get<Campaign>(this.API_CAMPAIGN_USER_URL);
  }

  getCampaignDataByUserName(userName): Observable<Campaign> {
    return this.http.get<Campaign>(this.API_CAMPAIGN_USER_URL + "/" + userName);
  }

  getCampaignsByYear(anio): Observable<CampaignDTO[]> {
    const userToken = localStorage.getItem(environment.authTokenKey);
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("Authorization", "Bearer " + userToken);
    httpHeaders.set("Content-Type", "application/json");

    return this.http.get<CampaignDTO[]>(this.API_CAMPAIGNS_URL + "/year/" + anio, { headers: httpHeaders });
  }

  getCampaignById(id): Observable<CampaignDTO> {
    const userToken = localStorage.getItem(environment.authTokenKey);
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("Authorization", "Bearer " + userToken);
    httpHeaders.set("Content-Type", "application/json");

    return this.http.get<CampaignDTO>(this.API_CAMPAIGNS_URL + "/" + id, { headers: httpHeaders });
  }

  saveCampaign(campaign: CampaignDTO): Observable<any> {
    const userToken = localStorage.getItem(environment.authTokenKey);
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("Authorization", "Bearer " + userToken);
    httpHeaders.set("Content-Type", "application/json");

    return this.http.post(this.API_CAMPAIGNS_URL, campaign, { headers: httpHeaders });
  }

  updateCampaign(campaign: CampaignDTO) {
    const userToken = localStorage.getItem(environment.authTokenKey);
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("Authorization", "Bearer " + userToken);
    httpHeaders.set("Content-Type", "application/json");

    return this.http.put(this.API_CAMPAIGNS_URL + "/" + campaign.id, campaign, { headers: httpHeaders });
  }

  getZones(id) {
    let httpHeaders = new HttpHeaders();
    httpHeaders.set("Content-Type", "application/json");

    return this.http.get<Zone[]>(this.API_CAMPAIGNZONES_URL + id, { headers: httpHeaders });
  }

  updateZone(zone: Zone) {
    const userToken = localStorage.getItem(environment.authTokenKey);
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("Authorization", "Bearer " + userToken);
    httpHeaders.set("Content-Type", "application/json");

    return this.http.put(this.API_CAMPAIGNZONES_URL + zone.id, zone, { headers: httpHeaders });
  }

  copyCampaignZonesPreviusCampaign(id) {
    return this.http.post(this.API_CAMPAIGNZONES_CLONE_URL, { toCampaignId: id });
  }

  exportScope(id): Observable<any> {
    let url = `${this.API_SCOPE_DOWNLOAD_URL}/${id}`;

    return this.http.get(url, { responseType: "blob" }).pipe(
      map((res) => {
        return new Blob([res], { type: "application/vnd.ms-excel" });
      })
    );
  }

  importScope(element, id) {
    return this.fileService.fileUpload(element, `${this.API_SCOPE_UPLOAD_URL}/${id}`);
  }
}
